var MvEcomIrwBagTypeEnum;
(function (MvEcomIrwBagTypeEnum) {
    MvEcomIrwBagTypeEnum["irwCart"] = "irw-shopping-cart";
    MvEcomIrwBagTypeEnum["irwList"] = "irw-shopping-list";
})(MvEcomIrwBagTypeEnum || (MvEcomIrwBagTypeEnum = {}));
export default MvEcomIrwBagTypeEnum;
//# sourceMappingURL=MvEcomIrwBagTypeEnum.js.map